import { UPDATE_CONFIG } from "action/ConfigAction";

interface ConfigState {
  amarBankWidget: boolean | null;
  customerServiceUrl: string | null;
  showCashBalance: boolean | null;
  showPointBalance: boolean | null;
  aboutAppsUrl: string | null;
  playstoreUrl: string | null;
}

const initialState: ConfigState = {
  amarBankWidget: null,
  customerServiceUrl: null,
  showCashBalance: null,
  showPointBalance: null,
  aboutAppsUrl: null,
  playstoreUrl: null
};

const configReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case UPDATE_CONFIG:
      return {
        ...state,
        amarBankWidget: action.payload.amarBankWidget,
        customerServiceUrl: action.payload.customerServiceUrl,
        showCashBalance: action.payload.showCashBalance,
        showPointBalance: action.payload.showPointBalance,
        aboutAppsUrl: action.payload.aboutAppsUrl,
        playstoreUrl: action.payload.playstoreUrl,
      };
    default:
      return state;
  }
};


export default configReducer;